import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import App from './components/App';
import ReportPage from './containers/MainReportPage';
import NotFoundPage from './containers/NotFoundPage.js';
import FeatureUnavailablePage from './containers/FeatureUnavailablePage.js';
import MeetingRoomPage from './containers/MeetingRoomPage.js';
import MeetingRoomManageUsersPage from './containers/MeetingRoomManageUsersPage.js';
import LoginPage from './containers/LoginPage.js';
import UserSignupPage from './containers/UserSignupPage';
import GroupPage from './containers/GroupPage.js';
import WaitingAreaPage from './containers/WaitingAreaPage.js';
import WaitingAreaViewOnePage from './containers/WaitingAreaViewOnePage.js';
import WaitingAreaManageUsersPage from './containers/WaitingAreaManageUsersPage.js';
import WaitingAreaManageTagsPage from './containers/WaitingAreaManageTagsPage.js';
import OrgUnitManageTagsPage from './containers/OrgUnitManageTagsPage.js';
import OrganisationalUnitManageUsersPage from './containers/OrganisationalUnitManageUsersPage.js';
import OrgUnitPage from './containers/OrgUnitPage.js';
import ManageAllUsersPage from './containers/ManageAllUsersPage.js';
import PortalSettingsPage from './containers/PortalSettingsPage.js';
import EntityAdminPage from './components/pages/org-unit/view/content.js';
import ScrollToTop from './components/shared/scrollToTop/content.js';
import VerifyEmailPage from './components/pages/user/verify-email/content.js';

// eslint-disable-line import/no-named-as-default

const routes = (props) => {
  return (
    <div>
      <ScrollToTop>
        <App />
        <Switch>
          <Route exact path="/" component={LoginPage} />
          <Route exact path="/signup" component={UserSignupPage} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/report" component={ReportPage} />
          <Route path="/verify-email" component={VerifyEmailPage} />
          <Route exact path="/groups/view-all" component={GroupPage} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/organisational-unit/view-all" component={OrgUnitPage} />
          <Route exact path="/organisational-unit/manage-tags/:id" component={OrgUnitManageTagsPage} />
          <Route exact path="/organisational-unit/manage-users/:id" component={OrganisationalUnitManageUsersPage} />
          <Route exact path="/meeting-room/view-all" component={MeetingRoomPage} />
          <Route exact path="/meeting-room/manage-users/:id" component={MeetingRoomManageUsersPage} />
          <Route exact path="/waiting-area/view-all" component={WaitingAreaPage} />
          <Route exact path="/portal-settings/view-all" component={PortalSettingsPage} />
          <Route exact path="/waiting-area/view-one/:id" component={WaitingAreaViewOnePage} />
          <Route exact path="/waiting-area/manage-users/:id" component={WaitingAreaManageUsersPage} />
          <Route exact path="/waiting-area/manage-tags/:id" component={WaitingAreaManageTagsPage} />
          <Route exact path="/user/view-all" component={ManageAllUsersPage} />
          <Route exact path="/upgrade" component={() => <FeatureUnavailablePage dispatch={props.dispatch} />} />
          <Route component={() => <NotFoundPage routeName="NotFound" dispatch={props.dispatch} />} />
        </Switch>
      </ScrollToTop>
    </div>
  );
};
export default routes;
